//
//
//
//
//
//
//
//
//
//
//
//

import SearchItemDropdown from '@/components/search/SearchItemDropdown'

export default {
  name: 'CountriesDropdown',
  components: { SearchItemDropdown },
  props: {
    selected: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * Array of countries
     * @returns {[]}
     */
    countries () {
      return this.$store.state.util.countries
    },

    label () {
      return this.selected ? this.countries.find(c => c.id === this.selected).name : this.$t('freelancers.country')
    }
  },
  methods: {
    selectCountry (c) {
      this.$emit('select', c.id)
    },

    removeCountry () {
      this.$emit('select', null)
    }
  }
}
